import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { ReservationTag } from '../model/reservation-tag';

@Component({
  selector: 'app-dietary-tag-modal',
  templateUrl: './dietary-tag-modal.component.html',
  styleUrls: ['./dietary-tag-modal.component.scss']
})
export class DietaryTagModalComponent implements OnInit {

  @ViewChild('modal') modal!: ModalDialogComponent;

  @Input() modalId: string = 'dietary-tag-modal';
  @Input() selectedTag: ReservationTag = new ReservationTag();
  @Output() onClose: EventEmitter<ReservationTag> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  show() {
    this.modal.show();
  }

  modalClosed(ok: boolean): void {
    if (ok == false) {
      return;
    }

    this.onClose.emit(this.selectedTag);
  }

}
